var _this = this;
// Our events object.
// This keeps tracks of key (function name) and value (callback functions) pairs.
var events = {};
// For internal events scoped to the widget
var eventsSystem = function (config) {
    if (!events[config._widgetInstanceId]) {
        events[config._widgetInstanceId] = {
            on: function (type, handler) {
                if (!handler) {
                    throw new ReferenceError('handler not defined.');
                }
                if (!events[config._widgetInstanceId][type]) {
                    events[config._widgetInstanceId][type] = [];
                }
                // Statistics is reserved once for the widgets
                // mensenlinq-event is reserved for the customer to tap into
                if ((type === 'statistics' || type === 'mensenlinq-event') &&
                    events[config._widgetInstanceId][type].length > 0) {
                    return _this;
                }
                else {
                    events[config._widgetInstanceId][type].push(handler);
                }
                return _this;
            },
            emit: function (type) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                if (events[config._widgetInstanceId][type]) {
                    var handlers = events[config._widgetInstanceId][type];
                    for (var _a = 0, handlers_1 = handlers; _a < handlers_1.length; _a++) {
                        var handler = handlers_1[_a];
                        handler.apply(_this, args);
                    }
                }
            },
        };
    }
    return events[config._widgetInstanceId];
};
export default eventsSystem;
